import { isElement } from '../detectInlineType';

import { type DOMNode, domToReact, type Element } from 'html-react-parser';

export interface InlineMapProps {
  element: Element;
}

export function InlineMap({ element }: InlineMapProps) {
  const figure = (element.children as DOMNode[]).find(isElement);
  const figureChildren = (figure?.children ?? []) as DOMNode[];
  const img = figureChildren.find((c): c is Element => isElement(c) && c.name === 'img');
  const figcaptionEl = figureChildren.find((c): c is Element => isElement(c) && c.name === 'figcaption');

  return (
    <a {...element.attribs}>
      <figure className={figure?.attribs?.class ?? undefined}>
        {img && (
          <img
            src={img.attribs?.src}
            height={img.attribs?.height}
            alt={element.attribs?.['data-caption'] ?? ''}
          />
        )}
        {figcaptionEl && <figcaption>{domToReact(figcaptionEl.children as DOMNode[])}</figcaption>}
      </figure>
    </a>
  );
}
